import styled from 'styled-components';

import {Tag} from 'components/ui-kit/Tags';

import {colors, font} from 'theme';

export const Form = styled.form`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
`;

export const HeadlineH2 = styled.div`
    white-space: nowrap;
    font-family: ${font.family.primary};
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
    color: ${colors.darkGrey};
`;

export const Headline = styled.h2`
    font-family: ${font.family.primary};
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
    color: #3f3f3f;
    margin: 0;
    padding: 0;
`;

export const SubText = styled.div`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #3b4156;
    margin: 0;
    padding: 0;
`;

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const FormControlWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 10px;
`;

export const ControlItem = styled.div``;

export const EmptyDataComponent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 60px 0 204px;
`;

// export const StatusWrapper = styled.div<{color: string}>`
//     display: inline-flex;
//     align-items: center;
//     justify-content: center;
//     gap: 4px;
//     padding: 4px 8px;
//     border-radius: 4px;
//     background-color: ${(props) => props.color};
//     color: ${colors.white};
//     font-size: 12px;
//     font-weight: 500;
//     line-height: 16px;
//     text-transform: uppercase;
//     font-family: Inter;
// `;
export const StatusWrapper = styled(Tag)`
    padding: 7px 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
`;
